import { useCallback, useEffect, useMemo, useState } from 'react';
import { activateUser, deactivateUser, getUsers } from '../api/usersApi';

const mapUserRow = (user) => ({
  id: user.id,
  nombre: `${user.firstname} ${user.lastname}`,
  profesional: user.profesional,
  createdAt: user.createdAt,
  active: user.active,
});

export const useUsersAdminTable = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterId, setFilterId] = useState('');
  const [filterNombre, setFilterNombre] = useState('');
  const [filterProfesional, setFilterProfesional] = useState('');
  const [sortDate, setSortDate] = useState(null);

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getUsers();
      setRows(data.map(mapUserRow));
    } catch (error) {
      console.error('Error al obtener los usuarios:', error);
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const filteredRows = useMemo(() => (
    rows
      .filter((row) => filterId === '' || row.id.toString().includes(filterId))
      .filter((row) => filterNombre === '' || row.nombre.toLowerCase().includes(filterNombre.toLowerCase()))
      .filter((row) => filterProfesional === '' || row.profesional.toString() === filterProfesional)
      .sort((a, b) => {
        if (sortDate === 'asc') return new Date(a.createdAt) - new Date(b.createdAt);
        if (sortDate === 'desc') return new Date(b.createdAt) - new Date(a.createdAt);
        return 0;
      })
  ), [rows, filterId, filterNombre, filterProfesional, sortDate]);

  const toggleUserActive = async (row) => {
    if (row.active) {
      await deactivateUser(row.id);
    } else {
      await activateUser(row.id);
    }
    await fetchUsers();
  };

  return {
    rows: filteredRows,
    loading,
    filterId,
    setFilterId,
    filterNombre,
    setFilterNombre,
    filterProfesional,
    setFilterProfesional,
    sortDate,
    setSortDate,
    fetchUsers,
    toggleUserActive,
  };
};
